import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.2, 0.8, 0.2, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, light = false, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal><p className="eyebrow">{eyebrow}</p></Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display mt-3 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl ${light ? "text-white" : "text-[var(--ink)]"}`}>{title}</h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-4 text-base leading-relaxed sm:text-lg ${light ? "text-white/70" : "text-[var(--mist)]"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
